import { Tabs } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmCardFormStore } from "../../MdmCardFormStore";
import { FormTabs } from "../../types/MdmCardFormTypes";

interface PropsTabsView {
  form: MdmCardFormStore;
  tabsItem: FormTabs;
}

export const TabsView: React.FC<PropsTabsView> = observer((props) => {
  const { tabsItem, form } = props;
  const { curKey, meta, tabs } = tabsItem;
  return (
    <Tabs
      activeKey={curKey}
      onChange={(key) => tabsItem.setCurKey(key)}
      style={{ padding: 6, border: "thin solid silver" }}
      items={meta.tabs.map(({ key, label }) => ({
        key,
        label,
        children: tabs[key]?.render(form),
      }))}
    />
  );
});
